
import * as types from "../types/pinModal"

const initialState = { open: false }

const ordersOfOrderPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.OPEN_PIN_MODAL:
      return { open: true }
    case types.CLOSE_PIN_MODAL:
      return { open: false }
    default:
      return state
  }
}

export default ordersOfOrderPageReducer